import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Image} from 'semantic-ui-react';

import paths from '@paths';
// TODO S3のパスに置き換えて定数化する
import {TWITTER} from './../../../../assets/images';

import './index.scss';

const Fotter: React.FC = () => {
  return (
    <div className="a__footer">
      <div className="w__footer-contents">
        <div className="w__footer-left">
          <div className="w__lists">
            <Link className="w__text" to={paths.terms.main}>
              <span>利用規約</span>
            </Link>
            <Link className="w__text" to={paths.commercial.main}>
              <span>特定商取引に基づく表記</span>
            </Link>
            <Link className="w__text" to={paths.privacyPolicy.main}>
              <span>プライバシーポリシー</span>
            </Link>

            <Link className="w__text" to={paths.questions.main}>
              <span>よくある質問</span>
            </Link>
          </div>
        </div>
        <div className="vertical-divier" />
        <div className="w__footer-right">
          <div className="w__lists">
            <Link className="w__text" to={paths.price.main}>
              <span className="b__label">プランについて</span>
            </Link>

            <Link className="w__text" to={paths.options.main}>
              <span className="b__label">エンタープライズプランのご相談</span>
            </Link>

            <Link className="w__text" to={paths.contact.main}>
              <span className="b__label">お問い合わせ</span>
            </Link>
            <Link className="w__text" to={paths.reason.main}>
              <span className="b__label">AnpiCheckerに込められた想い</span>
            </Link>
          </div>
        </div>
        <div className="w__information">
          <div className="w__copy-right">
            <a className="copy-right-text" href="https://www.taf-jp.com/">
              ©︎&nbsp;2021 &nbsp; Turn and Frontier
            </a>
          </div>
          <div className="w__sns">
            <Button
              className="b__icon"
              onClick={() =>
                window.location.assign('https://twitter.com/TurnandFrontier')
              }
            >
              <Image src={TWITTER} className="b__image" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fotter;
